module.exports = __webpack_public_path__ + "static/media/group_6.c61af488.svg";